import AnimatedPage from "../../animations/AnimatedPage";
import classes from "./about.module.css";
import {Card, Col, Container, Row} from "react-bootstrap";
import vo_chto from "../../images/vo-chto.jpg"
import symbol_veri from "../../images/symbol-veri.jpg"

const About = () => {
  return (
      <div className={classes.wrapper}>
        <AnimatedPage>
          <Container className="py-5">
            <Row className="justify-content-center">
              <Col md={10} lg={8}>
                <h2 className="text-center fw-bold mb-4">Во что мы верим</h2>
                <img className={`w-100`} src={vo_chto} alt="vo_chto" />
                <p>
                  Символом веры называется краткое систематизированное изложение
                  основных вероучительных истин Священного Писания, без доказательств
                  и объяснений.
                </p>
                <p>
                  Именно символы веры относились, прежде всего, к научению и крещению,
                  суммируя обширное спасительное учение Христа в краткой формуле веры
                  в Триединого Бога Отца, Сына и Святого Духа.
                </p>
                <p>
                  Во многих церквях древнего мира возрожденный, наученный основам
                  христианской веры человек должен был перед крещением предстать
                  перед многими свидетелями, чтобы исповедовать свою веру и ответить
                  на определенные вопросы. Эта практика имела основой слова апостола
                  Павла, сказанные Тимофею: <em>«Ты и призван, и исповедал доброе
                  исповедание пред многими свидетелями»</em> — <strong>1 Тим. 6, 12</strong>.
                </p>
                <p>
                  Поэтому и нам нужно уметь разумно и кратко сформулировать своё
                  мировоззрение, свою веру — для самого себя и для свидетельства людям.
                </p>
              </Col>
            </Row>

            <Row className="justify-content-center mt-4">
              <Col md={10} lg={8}>
                <Card className="shadow-sm border-0">
                  <Card.Body>
                    <h4 className="text-center fw-bold mb-3">Апостольский Символ Веры</h4>
                    <img className={`w-100`} src={symbol_veri} alt={`img`}/>
                    <p>
                      Верую в Бога, Отца Вседержителя, Творца неба и земли. И в Иисуса
                      Христа, Единородного Сына Божьего, Господа нашего. Зачатого от
                      Святого Духа и рождённого девой Марией; страдавшего при Понтии
                      Пилате; распятого, умершего, погребённого и воскресшего на третий
                      день из мёртвых, восшедшего на небеса и сидящего одесную Бога Отца
                      Всемогущего; откуда придёт Он судить живых и мёртвых.
                    </p>
                    <p>
                      Верую во Святого Духа. Верую во святую вселенскую церковь,
                      общение святых, прощение грехов, воскресение из мёртвых и жизнь
                      вечную.
                    </p>
                    <p className="text-end fw-semibold fst-italic mb-0">Аминь.</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </AnimatedPage>
      </div>
  );
};

export default About;
